import { render } from "./SystemColorPickerView.vue?vue&type=template&id=50b43a44&scoped=true&ts=true"
import script from "./SystemColorPickerView.vue?vue&type=script&lang=ts"
export * from "./SystemColorPickerView.vue?vue&type=script&lang=ts"

import "./SystemColorPickerView.vue?vue&type=style&index=0&id=50b43a44&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b43a44"]])

export default __exports__